import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "heading" }
const _hoisted_2 = {
  key: 0,
  class: "subheading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    class: ['kn-tab-card--icon', 'selectable', _ctx.selected ? 'selected' : '']
  }, {
    content: _withCtx(() => [
      _createVNode("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.element.label)) + " ", 1),
        (_ctx.badge && _ctx.badge > 0)
          ? (_openBlock(), _createBlock(_component_Badge, {
              key: 0,
              value: _ctx.badge
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.element.description)
        ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.element.description)), 1))
        : _createCommentVNode("", true),
      _createVNode("i", {
        class: ['icon', _ctx.element.icon]
      }, null, 2)
    ]),
    _: 1
  }, 8, ["class"]))
}